/**
 * Created by Jerker Nord on 2018-11-26.
 */
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {RespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/RespinZeroBetController";
import {ThorGameMode} from "../gamemode/ThorGameMode";

export class ThorNudgeRespinZeroBetController extends RespinZeroBetController {

    constructor() {
        super();
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        if(data.nextMode == ThorGameMode.NUDGE_RESPIN
            || (data.mode == ThorGameMode.NUDGE_RESPIN && data.nextMode == ThorGameMode.NUDGE_RESPIN)
            || ((<ParsedInitData>data).isRestoreState && data.mode == ThorGameMode.NUDGE_RESPIN && data.nextMode == ThorGameMode.NORMAL)) {
            return true;
        } else {
            return false;
        }
    }
}